
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import TemplateView from "../components/template.vue";
import Dialog from "../components/delete-dialog.vue";
import Loading from "../../../components/loading.vue";
import draggable from "vuedraggable";
import OptionDetail from "../components/option-detail.vue";
import OptionEdit from "../components/option-edit.vue";
import DelDialog from "../components/delete-dialog.vue";

import {
  ExamV3,
  HeaderOption,
  AllOptionText,
  Video
} from "@/lib/model/workerbuilder/exam-v3";

class TypeList {
  pType = "";
  list: HeaderOption[] = [];
}
@Component({
  components: {
    TemplateView,
    Dialog,
    Loading,
    draggable,
    OptionDetail,
    OptionEdit,
    DelDialog
  }
})
export default class SetDimension extends Vue {
  @Prop({ type: ExamV3, default: null }) exam!: ExamV3; //考试Model
  @Prop({}) companyPower!: any; //公司权限
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答

  arr1: HeaderOption[] = []; //123 核心 重点 一般
  arr2: HeaderOption[] = [];
  arr3: HeaderOption[] = [];

  askDel = false;
  delItem = new HeaderOption();
  optionTypeList: TypeList[] = []; //全部类型
  AllOptionText = new AllOptionText().op; //全部文案
  showEdit = false; //编辑考察项
  editParam = new HeaderOption();
  editParamKey = "";
  editIndex = 0; //编辑自定义中的序号
  hidePop = false; //隐藏详细pop
  CP: any = {}; //公司权限；

  @Watch("exam", { deep: true, immediate: true })
  initData() {
    this.formData.name = this.exam.name;
    this.formData.remark = this.exam.remark;
    this.change();
  }

  formData = {
    name: "",
    remark: ""
  };
  rules = {
    name: [
      { required: true, message: "请输入面试名称", trigger: "change" }
      // { max: 12, message: "最多12个字符", trigger: "blur" }
    ]
  };
  dataReady = false;
  questionList: any = [];

  async getVideo() {
    await Video.getList({ dimension: "all" }).then(res => {
      if (res.data.code === 0) {
        this.questionList = res.data.data.list;
      }
    });
  }
  //后端自定义视频考察项
  getVideoDiyList(key: string) {
    const res: any = [];
    const i = this.exam.headerOptions.findIndex(d => {
      return d.optionName === key;
    });
    if (i !== -1) {
      this.exam.headerOptions[i].videoQuestionIdList.forEach(d => {
        const ii = this.questionList.findIndex((q: any) => {
          return q?.questionId === d;
        });
        if (ii !== -1) {
          res.push(this.questionList[ii].descTextOnly);
        }
      });
    }
    return res;
  }

  //形象素质
  get video1List() {
    const res: any = [];
    const i = this.exam.headerOptions.findIndex(d => {
      return d.type === "形象素质";
    });
    if (i !== -1) {
      this.exam.headerOptions[i].videoQuestionIdList.forEach(d => {
        const ii = this.questionList.findIndex((q: any) => {
          return q?.questionId === d;
        });
        if (ii !== -1) {
          res.push(this.questionList[ii].descTextOnly);
        }
      });
    }
    return res;
  }
  //沟通表达
  get video2List() {
    const res: any = [];
    const i = this.exam.headerOptions.findIndex(d => {
      return d.type === "沟通表达";
    });
    if (i !== -1) {
      this.exam.headerOptions[i].videoQuestionIdList.forEach(d => {
        const ii = this.questionList.findIndex((q: any) => {
          return q?.questionId === d;
        });
        if (ii !== -1) {
          res.push(this.questionList[ii].descTextOnly);
        }
      });
    }
    return res;
  }
  //视频题 默认第一道题
  setDefVideo() {
    const i = this.exam.headerOptions.findIndex(d => {
      return d.type === "沟通表达";
    });
    const i2 = this.exam.headerOptions.findIndex(d => {
      return d.type === "形象素质";
    });
    if (
      i !== -1 &&
      this.exam.headerOptions[i].videoQuestionIdList.length === 0
    ) {
      this.exam.headerOptions[i].videoQuestionIdList.push(
        this.questionList?.[0]?.questionId
      );
    }
    if (
      i2 !== -1 &&
      this.exam.headerOptions[i2].videoQuestionIdList.length === 0
    ) {
      this.exam.headerOptions[i2].videoQuestionIdList.push(
        this.questionList?.[0]?.questionId
      );
    }
  }

  created() {
    this.CP = this.companyPower;
  }

  mounted() {
    this.setOption();
    this.dataReady = true;
    setTimeout(() => {
      console.log(this.optionTypeList);
    }, 100);
  }
  //组装二级格式
  async setOption() {
    if (this.exam.headerOptions.length < 2) return;

    await this.getVideo(); //更新视频题库
    this.setDefVideo();

    //先清
    this.optionTypeList = [];
    this.arr1 = [];
    this.arr2 = [];
    this.arr3 = [];

    this.exam.headerOptions.forEach((d: HeaderOption) => {
      const i = this.optionTypeList.findIndex((m: TypeList) => {
        return m.pType === d.pType;
      });
      // *****组装左侧总池列表**********
      //---未有的
      if (i === -1) {
        const t = new TypeList();
        t.pType = d.pType;
        t.list.push(d);
        this.optionTypeList.push(t);
      } else {
        //---已有的
        this.optionTypeList[i].list.push(d);
      }

      //*****组装右侧已选列表***********
      // ---已选的一级项 则加入右侧
      if (d.useLevel !== 0) {
        const i = this["arr" + d.useLevel].findIndex((m: HeaderOption) => {
          return (
            (!["通用单选", "通用视频"].includes(d.type) && d.type === m.type) ||
            (["通用单选", "通用视频"].includes(d.type) &&
              d.optionName === m.optionName)
          );
        });
        if (i === -1) {
          this["arr" + d.useLevel].push(d);
        }
      }
      //---已选的二级项（多选）  模拟成一级项后 加入右侧
      if (d.type === "通用多选") {
        d.paramUseRuleList.forEach((p, i) => {
          if (p.useLevel !== 0) {
            const param = new HeaderOption();
            param.edit = d.defaultMulti !== 1; //可编辑
            param.defaultMulti = d.defaultMulti;
            // param.type = p.keyName;
            param.optionName = p.keyName;
            param.type = "通用多选";
            param.useLevel = p.useLevel;
            param.useSort = p.useSort;
            this["arr" + p.useLevel].push(param);
          }
        });
      }
    });
    // this.setSelectQuestion();
    this.sortRight();
  }
  //组装后 刷下单多选格式
  setSelectQuestion() {
    // const list = this.optionTypeList.find((d: TypeList) => {
    //   return d.pType === "个人信息及岗位要求";
    // });
    // if (!list) return;
    // list.list.forEach((d: HeaderOption, i: number) => {
    //   if (d.type === "通用多选") {
    //     // d.type = d.optionName;
    //     // this.optionTypeList["个人信息及岗位要求"].splice(i, 1, d);
    //   }
    //   if (d.type === "通用单选") {
    //     // d.type = d.optionName;
    //   }
    // });
  }

  //公司权限
  hasPower(item: HeaderOption) {
    if (
      [
        "人脸识别",
        "换人检测",
        "抑郁自杀倾向",
        "暴力反社会倾向",
        "负面社会安全记录",
        "金融黑名单",
        "认知能力",
        "手机号实名认证"
      ].includes(item.type)
    ) {
      const res =
        (item.type === "人脸识别" && this.CP.livenessRecognition === 1) ||
        (item.type === "换人检测" && this.CP.enableReplacePersonCheck === 1) ||
        (item.type === "抑郁自杀倾向" && this.CP.enablePsycTest === 1) ||
        (item.type === "暴力反社会倾向" && this.CP.enablePsycTest === 1) ||
        (item.type === "认知能力" && this.CP.enableGameTest === 1) ||
        (item.type === "负面社会安全记录" && this.CP.enableBadHistroy === 1) ||
        (item.type === "金融黑名单" && this.CP.enableMoneyCheck === 1) ||
        (item.type === "手机号实名认证" &&
          this.CP.enablePeoplePhoneCheck === 1);
      return res;
    } else {
      return true;
    }
  }
  //新增自定义考察项
  addDiyOption() {
    this.editParamKey = "新建";
    this.editParam = new HeaderOption();
    this.editIndex = 0;
    // this.option =
    this.$nextTick(() => {
      this.showEdit = true;
    });
  }
  //编辑
  edit(item: HeaderOption) {
    this.editParamKey = item.type;
    this.editParam = item;
    //编辑自定义 回传用
    this.editIndex = this.exam.headerOptions.findIndex(d => {
      return d.optionName === item.optionName;
    });
    this.$nextTick(() => {
      this.showEdit = true;
    });

    //保存下排序
    this.sortOptions();
    // this.sortRight();
  }
  //右侧 多选选项 模拟编辑
  editMultiOption(option: HeaderOption) {
    //找到实际父级考察项
    const res: HeaderOption | undefined = this.exam.headerOptions.find(
      (d, i) => {
        if (d.type === "通用多选") {
          const ii: number = d.param.mutiChoiceOptions.findIndex((o, p) => {
            return o.key === option.optionName;
          });
          return ii !== -1;
        }
      }
    );
    if (res) {
      this.edit(res);
    } else {
      this.$message.warning("网络开小差了，请在左侧列表中编辑此项吧");
    }
  }
  del(item: HeaderOption) {
    this.delItem = item;
    this.askDel = true;
  }

  delReal() {
    const ii = this.exam.headerOptions.findIndex(d => {
      return d.optionName === this.delItem.optionName;
    });
    if (ii !== -1) {
      this.exam.headerOptions.splice(ii, 1);
      this.setOption();
    }
    this.askDel = false;
    this.$message.success("删除成功");
  }
  cancelEdit() {
    this.showEdit = false;
  }
  //编辑后保存
  saveEdit(e: HeaderOption) {
    this.showEdit = false;
    //自定义字段
    if (["通用单选", "通用多选"].includes(e.type)) {
      if (this.editIndex) {
        //编辑
        this.exam.headerOptions.splice(this.editIndex, 1, e);
      } else {
        //新增
        this.exam.headerOptions.push(e);
      }
    } else {
      //系统字段
      const ii = this.exam.headerOptions.findIndex((d: HeaderOption) => {
        return (
          (!["通用视频"].includes(d.type) && d.type === this.editParamKey) ||
          (["通用视频"].includes(d.type) &&
            d.optionName === this.editParam.optionName)
        );
      });
      if (ii !== -1) {
        //编辑
        this.exam.headerOptions.splice(ii, 1, e);
      } else {
        //新增
        this.exam.headerOptions.push(e);
      }
    }
    //更新
    this.setOption();

    console.log(this.exam.headerOptions);
  }

  //下一步前 校验
  checkData() {
    let res = true;
    //至少一个考察项
    const sum = this.arr1.length + this.arr2.length + this.arr3.length;
    if (sum === 0) {
      this.$message.warning("请至少选择一个考察项");
      res = false;
      return;
    }
    //选了视频题 则至少一道
    const v1 = this.exam.headerOptions.find(v => {
      return v.type === "形象素质";
    });
    const v2 = this.exam.headerOptions.find(v => {
      return v.type === "沟通表达";
    });
    if (
      v1 &&
      v2 &&
      v1.useLevel + v2.useLevel > 0 &&
      v1.videoQuestionIdList.length + v2.videoQuestionIdList.length === 0
    ) {
      this.$message.warning("请选择至少一道视频题作为形象素质或沟通表达的题目");
      return;
    }
    //表单
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        //
      } else {
        res = false;
      }
    });
    this.sortOptions();
    return res;
  }

  //下一步前：已选考察项排序
  sortOptions() {
    //先归零
    this.exam.headerOptions.forEach(d => {
      d.useSort = 0;
      d?.paramUseRuleList.forEach(p => {
        p.useSort = 0;
      });
    });
    //开排
    for (const arrIndex of [1, 2, 3]) {
      this["arr" + arrIndex].forEach((op: any, i: number) => {
        if (op.type === "通用多选") {
          //二级配置项
          const ii = this.exam.headerOptions.findIndex(h => {
            const iii = h.paramUseRuleList.findIndex(dd => {
              return dd.keyName === op.optionName;
            });
            return iii !== -1;
          });
          this.exam.headerOptions[ii].paramUseRuleList.forEach(option => {
            if (option.keyName === op.optionName && option.useLevel !== 0) {
              option.useSort =
                i +
                1 +
                (this["arr" + (arrIndex - 1)]?.length || 0) +
                (this["arr" + (arrIndex - 2)]?.length || 0);
            }
          });
        } else {
          //一级配置项
          const ii = this.exam.headerOptions.findIndex(h => {
            return (
              (!["通用视频", "通用单选"].includes(h.type) &&
                h.type === op.type) ||
              (["通用视频", "通用单选"].includes(h.type) &&
                h.optionName === op.optionName)
            );
          });
          if (ii !== -1) {
            this.exam.headerOptions[ii].useSort =
              i +
              1 +
              (this["arr" + (arrIndex - 1)]?.length || 0) +
              (this["arr" + (arrIndex - 2)]?.length || 0);
          }
        }
      });
    }

    const resShow = this.exam.headerOptions.filter(res => {
      const iii = res.paramUseRuleList.findIndex(dd => {
        return dd.useSort !== 0;
      });
      return res.useSort !== 0 || iii !== -1;
    });
    console.log(resShow);
  }

  //右侧回显后排序
  sortRight() {
    for (const i of [1, 2, 3]) {
      this["arr" + i].sort((a: HeaderOption, b: HeaderOption) => {
        return a.useSort - b.useSort;
      });
    }
  }

  onDataChange() {
    this.exam.name = this.formData.name;
    this.exam.remark = this.formData.remark;
    this.change();
  }

  @Emit()
  change() {
    return;
  }

  //**********拖拽相关******
  //拖入右侧
  leftToRight(to: any, some: any) {
    const type = to?.item?.id;
    const level = Number(to?.to?.id?.slice(3)); //目标lv

    const item: HeaderOption = this[to.to.id][to.newIndex]; //拖动的考察项

    this[to.to.id].forEach((d: HeaderOption) => {
      d.useLevel = level;
    });
    if (["通用单选", "通用视频"].includes(item.type)) {
      //diy的 or 单选的
      this.setExamOpLvDiy(item, level);
    } else if (item.type === "通用多选") {
      this.changeOptionLevel(item.optionName, level);
    } else {
      //系统考察项
      this.setExamOpLv(type, level);
    }
  }
  //变更exam option level
  setExamOpLv(type: string, level: number) {
    const i = this.exam.headerOptions.findIndex(d => {
      return d.type === type;
    });
    if (i !== -1) {
      //一级配置项（默认 or 单选）
      this.exam.headerOptions[i].useLevel = level;
    } else {
      //二级配置项(多选)
      this.changeOptionLevel(type, level);
    }
  }
  //拖了自定义的
  setExamOpLvDiy(item: HeaderOption, level: number) {
    const i = this.exam.headerOptions.findIndex(d => {
      return d.optionName === item.optionName;
    });
    if (i !== -1) {
      //一级配置项（单选）
      this.exam.headerOptions[i].useLevel = level;
    }
  }
  //右侧 点删除
  delOption(arr: string, type: string, i: number) {
    this[arr].splice(i, 1);
    this.setExamOpLv(type, 0);
  }

  //下拉变更  params: 自身数组 变更类型 目标lv 自身index
  selectLv(arr: string, item: HeaderOption, lv: number, i: number) {
    if (this.isCandidateUsed) return;
    //右侧下拉改变
    if (i !== -1) {
      //自身删除
      if (Number(arr.slice(3)) !== lv) {
        this[arr].splice(i, 1);
      }
      //目标增加
      if (lv !== 0) {
        this["arr" + lv].push(item);
      }
      //如果是二级配置项
      if (
        item.type === "通用多选"
        // !this.exam.headerOptions.find((pp) => {
        //   return pp.type === item.type;
        // })
      ) {
        this.changeOptionLevel(item.optionName, lv);
      }
    } else {
      //左侧下拉
      //先删
      this.cleanRightType(item);
      //后加
      if (lv !== 0) {
        this["arr" + lv].push(item);
      }
    }
  }
  //左侧下拉后 删除右侧type
  cleanRightType(item: HeaderOption) {
    for (const i of [1, 2, 3]) {
      const ii = this["arr" + i].findIndex((d: HeaderOption) => {
        return (
          (!["通用单选", "通用视频"].includes(item.type) &&
            item.type === d.type) ||
          (["通用单选", "通用视频"].includes(item.type) &&
            item.optionName === d.optionName)
        );
      });
      if (ii !== -1) {
        this["arr" + i].splice(ii, 1);
      }
    }
  }
  //修改二级选项level
  changeOptionLevel(optionName: string, lv: number) {
    this.exam.headerOptions.forEach((d: HeaderOption) => {
      if (d.type === "通用多选") {
        d.paramUseRuleList.forEach((p: any) => {
          if (p.keyName === optionName) {
            p.useLevel = lv;
          }
        });
      }
    });
  }

  //左侧禁止互拖
  leftSort(e: any) {
    if (e.to.id === "optionAList") {
      return false;
    } else {
      return true;
    }
  }
  //从左拖到右开始时
  startLeftToRight() {
    console.log("stratLtoR");
    this.hidePop = true;
  }
  endLedtToRight() {
    console.log("endLtoR");
    this.hidePop = false;
  }

  //左侧 二级项 多选下拉
  selectOptionLv(item: HeaderOption, option: any, lv: number) {
    if (this.isCandidateUsed) return;

    //先删
    this.cleanRightTypeOption(item, option);
    //后加
    if (lv !== 0) {
      //模拟个一级HeaderOption
      const p = new HeaderOption();
      p.edit = item.defaultMulti !== 1;
      p.defaultMulti = item.defaultMulti;
      // p.type = option.keyName;
      p.optionName = option.keyName;
      p.type = "通用多选";
      p.useLevel = lv;
      this["arr" + lv].push(p);
    }
  }
  //配置项-左侧下拉后 删除右侧 （多选）
  cleanRightTypeOption(item: HeaderOption, option: any) {
    for (const i of [1, 2, 3]) {
      const ii = this["arr" + i].findIndex((d: HeaderOption) => {
        return d.optionName === option.keyName;
      });
      if (ii !== -1) {
        this["arr" + i].splice(ii, 1);
      }
    }
  }

  //放回总池
  addToAll(to: any, from: any, a: any, b: any, c: any) {
    // const arr = to.to.id;
    // this[arr].splice(to.newDraggableIndex, 1);
    // return false;
  }
  //从总池取出
  addFromAll(to: any, from: any, a: any, b: any, c: any) {
    // this.arr2.splice(to.newDraggableIndex, 1);
    // return false;
  }
  updateAll(e: any) {
    // ;
  }
  //设置左侧不可拖动项目
  setForbid(it: HeaderOption) {
    function filter(d: HeaderOption) {
      return (
        (!["通用单选", "通用视频"].includes(d.type) && d.type === it.type) ||
        (["通用单选", "通用视频"].includes(d.type) &&
          d.optionName === it.optionName)
      );
    }

    let index = 0;
    index += this.arr1.findIndex(d => {
      return filter(d);
    });
    index += this.arr2.findIndex(d => {
      return filter(d);
    });
    index += this.arr3.findIndex(d => {
      return filter(d);
    });

    return index !== -3 || ["通用多选"].includes(it.type); //右侧已选 || 多选   都不可以从左侧拖出
  }

  setSub(item: HeaderOption) {
    return (
      this.AllOptionText?.[item.type]?.sub ||
      this.AllOptionText?.[item.optionName]?.sub
    );
  }
  canEdit(item: HeaderOption) {
    return this.AllOptionText?.[item.type]?.edit;
  }
  //是否自定义考察项
  isDiy(item: HeaderOption) {
    return (
      !this.AllOptionText?.[item.type] && !this.AllOptionText?.[item.optionName]
    );
  }
}
